import type { Fallacy } from "./types";
import { createStory } from "./types";

export const tragedyOfCommons: Fallacy = {
    id: "tragedy-of-commons",
    name: "Tragedy of the Commons",
    emoji: "🌍",
    category: "Jebakan Strategi",
    description: "\"Satu plastik nggak ngaruh.\" **Rasional individu**, tapi **bencana kolektif**.",
    tldr: "\"Kontribusiku kecil, nggak ngaruh\" — tapi kalau semua orang berpikir begitu, dampaknya masif.",
    detail: "Tragedy of the Commons menggambarkan situasi di mana setiap individu bertindak rasional untuk kepentingan pribadinya, tetapi secara kolektif **menghasilkan kehancuran sumber daya bersama**. Dipopulerkan Garrett Hardin (1968) dengan analogi padang rumput bersama yang rusak karena setiap penggembala menambah ternak tanpa batas.\n\nDalam kehidupan modern: \"Satu kantong plastik nggak ngaruh\" — tapi 270 juta orang berpikir sama, hasilnya jutaan ton sampah per tahun. Masing-masing merasa kontribusinya terhadap masalah kecil — dan memang benar secara individual. Tapi dijumlahkan, dampaknya masif.\n\nSolusinya bukan mengharapkan semua orang menjadi altruistis, melainkan **mendesain sistem yang menyelaraskan kepentingan individu dengan kepentingan kolektif** — melalui regulasi, insentif, atau norma sosial.",
    story: createStory("Tragedy of the Commons", "🌍", {
      hook: {
        title: "\"Satu plastik aku gak ngaruh.\"",
        body: "Bener sih. Tapi 270 juta orang mikir hal yang sama... hasilnya jutaan ton sampah.",
      },
      convo: {
        claim: "Temen ngajak bawa tumbler sendiri buat kurangin sampah plastik, tapi aku males. **Satu botol plastik dari aku gak ngaruh** apa-apa ke planet ini.",
        response: "270 juta orang mikir hal yang sama. **Itulah kenapa sampahnya jutaan ton.**",
      },
      reveal: {
        body: "Tiap individu ngerasa **kontribusinya ke masalah kecil** — dan emang bener. Tapi dijumlahkan, dampaknya **masif dan merusak** sumber daya bersama.",
      },
      insight: {
        title: "Masalahnya bukan orang jahat",
        body: "Tapi semua orang mikir kontribusinya **terlalu kecil buat ngaruh**. Padahal dijumlahkan, itulah yang bikin sumber daya bersama hancur.",
      },
      engagement: {
        title: "Pernah mikir \"ah satu doang gak ngaruh\"? 🌍",
        body: "Soal sampah, iuran, atau WiFi kantor? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["free-rider", "escalation-trap", "bandwagon"],
  };
